$(document).on('click', '.js-load-more-archives', function (event) {
  let series = $('.js-load-more-archives').attr('data-series');
  $('.js-load-more-archives').remove();
  loadArchive({ archives: { series: series }, page: 2 });
});

$(window).on('scroll', function () {
  if ($('.js-containar-end').length === 0) {
    return;
  }

  var containar_bottom = Math.round($('.js-containar-end').offset().top);

  if (containar_bottom < $(window).scrollTop() + $(window).innerHeight()) {
    let nextPage = $('.js-containar-end').attr('data-next-page');
    let series = $('.js-containar-end').attr('data-series');
    $('.js-containar-end').remove();
    if(nextPage > 0) {
      loadArchive({ archives: { series: series }, page: nextPage });
    }
  }
});

function loadArchive(params) {
  $.ajax({
    url: '/archives_list',
    type: 'GET',
    dataType: 'json',
    data: params,
    timeout: 5000,
  })
  .done(function(data) {
    data.archives.forEach(archive => {
      $('<li>').attr({ class: 'archive-list__li', style: 'display: none;' }).append(
        $('<a>').attr({ href: archive.url })
          .append(
            $('<figure>').append(
              $('<img>').attr({ class: 'archive-list__img', src: archive.image_url })
            )
          )
          .append(archive.series + ' ' + ( '000' + archive.volume ).slice( -3 ))
          .append($('<div class="published_on">' + archive.published_on.replaceAll('-', '.') + '</div>'))
          .append($('<div class="archive_title">' + archive.title + '</div>'))
          .append($('<div class="read_now">Read ></div>'))
      ).fadeIn(700).appendTo('.js-archive-container');
    });
    $('.js-archive-list').append('<div class="js-containar-end" data-next-page="' + data.next_page + '" data-series="' + params.archives.series + '">')
  });
}
